import { render, staticRenderFns } from "./poster-detail.vue?vue&type=template&id=53474fc6&"
import script from "./poster-detail.vue?vue&type=script&lang=js&"
export * from "./poster-detail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports